/**
 * Created by fers on 16.05.16.
 */
/* global Buffer */

import crypto from 'crypto';
import base64 from 'base-64';
import {convertVATtoCode} from '../constants/VAT';
import {stripHtml} from '../util/sanitizeHtml';
import moment from 'moment-timezone';

function asArray(array) {
    if (!Array.isArray(array)) {
        if (array !== null && array !== "") {
            return [array];
        } else {
            return [];
        }
    } else {
        let output = [];
        for (let a of array) {
            if (a === null || a === undefined) {
                /* ignore */
            } else if (Array.isArray(a)) {
                for (let a2 of a) {
                    if (a2 !== null && a2 !== undefined) {
                        output.push(a2);
                    }
                }
            } else {
                output.push(a);
            }
        }

        return output;
    }
}


function forEach(array, func) {
    array = asArray(array);

    return array.map((a) => func(a));
}

// eslint-disable-next-line max-params
function join(array, separator, prefix, suffix) {
    if (!separator) {
        separator = "";
    }
    if (!prefix) {
        prefix = "";
    }
    if (!suffix) {
        suffix = "";
    }

    if (!Array.isArray(array)) {
        if (array !== null && array !== "") {
            return prefix + array + suffix;
        } else {
            return array;
        }
    }

    let sep = "";
    let output = "";

    for (let a of array) {
        if (a === null || a === undefined) {
            /* ignore */
        } else if (Array.isArray(a)) {
            for (let a2 of a) {
                if (a !== null && a !== undefined) {
                    output += sep + prefix + a2 + suffix;
                    sep = separator;
                }
            }
        } else {
            output += sep + prefix + a + suffix;
            sep = separator;
        }
    }

    return output;
}

function addslashes(str) {
    return (str + '')
        .replace(/[\\"']/g, '\\$&')
        .replace(/\u0000/g, '\\0');
}

function addsingleslashes(str) {
    return (str + '')
        .replace(/[']/g, '\\$&')
        .replace(/\u0000/g, '\\0');
}

function tolower(str) {
    return String(str).toLowerCase();
}

function toupper(str) {
    return String(str).toUpperCase();
}

export function mergeArray(array) {
    let result = [];
    for (let arg of array) {
        if (arg !== null && arg !== undefined && arg !== "") {
            if (Array.isArray(arg)) {
                for (let a of arg) {
                    if (a !== null && a !== undefined && a !== "") {
                        result.push(a);
                    }
                }
            } else {
                result.push(arg);
            }
        }
    }

    return result;
}

function myRegex(str, regex, result) {
    // nosemgrep
    let r = new RegExp(regex);
    let re = str.replace(r, result);

    return re;
}

function sum(array) {
    let value;

    for (let item of array) {
        let a = myParseFloat(item);

        if (a !== undefined && !isNaN(a) && a !== null) {
            value = (value || 0) + a;
        }
    }

    return value;
}

// eslint-disable-next-line max-params
export function getVatType(vat : number, country : string, date: Date, base: number, tax: number, total: number) {
    if (country === '' || Array.isArray(country) && country.length === 0) {
        country = undefined;
    }
    if (date === '' || Array.isArray(date) && date.length === 0) {
        date = undefined;
    }
    if (base === '' || Array.isArray(base) && base.length === 0) {
        base = undefined;
    }
    if (tax === '' || Array.isArray(tax) && tax.length === 0) {
        tax = undefined;
    }
    if (total === '' || Array.isArray(total) && total.length === 0) {
        total = undefined;
    }
    if (vat === '' || Array.isArray(vat) && vat.length === 0) {
        vat = undefined;
    }
    return convertVATtoCode(country, vat, date, base, tax, total);
}

function myParseFloat(str) {
    if (str === undefined) {
        return undefined;
    }

    /* check format 100,00 (and only one comma) */
    if (typeof str === 'string' && str.indexOf(',') !== -1 && str.lastIndexOf('.') === str.indexOf(',')) {
        str = str.replace(/,/g, '.');
    }

    let res = parseFloat(str);
    if (isNaN(res)) {
        return undefined;
    } else {
        return res;
    }
}

let handlers = { //keys must be lowercase

    "base64": {
        to: (str) => forEach(str, base64.encode),
        from: (str) => base64.decode(str),
    },
    "regex": {
        to: (str) => str,
        from: (str) => str,
    },
    "abs": {
        to: (str) => forEach(str, (str) => {
            if (str === undefined) {
                return undefined;
            }
            
            return Math.abs(myParseFloat(str));
        }),
        from: (str) => str,
    },
    "parseint": {
        to: (str) => parseInt(str, 10),
        from: (str) => str,
    },
    "parsefloat": {
        to: (str) => myParseFloat(str),
        from: (str) => str,
    },
    "regexp": {
        to: (str, regex, result) => forEach(str, (str) => myRegex(str, regex, result)),
        from: (str) => str,
    },
    "regexpmatch": {
        to: (str, regex) => asArray(str).filter((a) => String(a || '').match(regex)).map((a) => {
            let res = String(a || '').match(regex);
            if (res && res.length > 1) {
                if (1 in res) {
                    return res[1];
                } else {
                    return res[0];
                }
            }
        }),
        from: (str) => str,
    },
    "substring": {
        to: (str, start, end) => forEach(str, (str) => {
            if (str === undefined) {
                return str;
            }

            return String(str).substring(start, end);
        }),
        from: (str) => str,
    },
    "sum": {
        to: (str) => sum(asArray(str)),
        from: (str) => str,
    },
    "digit": {
        to: (str) => str,
        from: (str) => str,
    },
    "length": {
        to: (str) => Array.isArray(str) ? str.length : String(str || '').length,
        from: (str) => str,
    },
    "strlen": {
        to: (str) => Array.isArray(str) ? str.length : String(str || '').length,
        from: (str) => str,
    },
    "alpha": {
        to: (str) => str,
        from: (str) => str,
    },
    "alnum": {
        to: (str) => str,
        from: (str) => str,
    },
    "vattype": {
        // eslint-disable-next-line max-params
        to: (vat, country, date, base, tax, total) => getVatType(vat, country, date, base, tax, total),
        from: (str) => str,
    },
    "if": {
        to: (cond, a, b) => {
            if (cond) {
                return a;
            } else {
                return b;
            }
        },
        from: (str) => str,
    },
    "url": {
        to: (str) => forEach(str, encodeURIComponent),
        from: (str) => forEach(str, decodeURIComponent),
    },
    "find": {
        to: (str, fc) => asArray(str).find((a) => fc(a)),
        from: (str, fc) => asArray(str).find((a) => fc(a)),
    },
    "format_date": {
        to: (str, format) => asArray(str).map((a) => {
            if (a === undefined || a === null || a === "") {
                return a;
            }
            try {
                let m = moment(a, "YYYY-MM-DDThh:mm:ss");
                if (m.isValid()) {
                    return m.format(format);
                } else {
                    return a;
                }
            } catch (e) {
                return a;
            }
        }).join(","),
        from: (str, format) => str,
    },
    "date": {
        to: (str) => asArray(str).map((a) => {
            if (a === "today") {
                return moment().startOf('day');
            } else if (a === "yesterday") {
                return moment().startOf('day').subtract(1, 'day');
            } else {
                return moment(str);
            }
        }),
        from: (str, format) => str,
    },
    "filter": {
        to: (str, fc) => asArray(str).filter((a) => fc(a)),
        from: (str, fc) => asArray(str).filter((a) => fc(a)),
    },
    "map": {
        to: (str, fc) => asArray(str).map((a) => fc(a)),
        from: (str, fc) => asArray(str).map((a) => fc(a)),
    },
    "get": {
        to: (map, key) => asArray(map).map((a) => a[key]),
        from: (map, key) => asArray(map).map((a) => a[key]),
    },
    "urlencode": {
        to: (str) => forEach(str, encodeURIComponent),
        from: (str) => forEach(str, decodeURIComponent),
    },
    "striphtml": {
        to: (str) => forEach(str, stripHtml),
        from: (str) => forEach(str, stripHtml),
    },
    "addslashes": {
        to: (str) => forEach(str, addslashes),
        from: (str) => str,
    },
    "addsingleslashes": {
        to: (str) => forEach(str, addsingleslashes),
        from: (str) => str,
    },
    "xmlescape": {
        to: (str) => forEach(str, (str) => String(str).replace(/[\u00A0-\u9999<>\&]/gim, (i) => '&#' + i.charCodeAt(0) + ';')),
        from: (str) => str,
    },
    "tolower": {
        to: (str) => forEach(str, tolower),
        from: (str) => str,
    },
    "upperfirst": {
        to: (str) => forEach(str, (text) => String(text)[0].toUpperCase() + String(text).slice(1)),
        from: (str) => str,
    },
    "toupper": {
        to: (str) => forEach(str, toupper),
        from: (str) => str,
    },
    "trim": {
        to: (str) => forEach(str, (str) => str.trim()),
        from: (str) => str,
    },
    "join": {
        to: join,
        from: (str) => str,
    },
    "first": {
        to: (arr) => join(arr, ""),
        from: (str) => str,
    },
    "removespaces": {
        to: (str) => forEach(str, (str) => str.replace(/\s/g, "")),
        from: (str) => str,
    },
    "coalesce": {
        to: (...args) => { for (let arg of args) { if (arg !== null && arg !== undefined && arg !== "") { return (arg); }}},
    },
    "array": {
        to: (...args) => {
            return mergeArray(args);
        },
    },
    "unique": {
        to: (arg) => {
            if (typeof arg === 'string') {
                arg = [arg];
            }

            return ([...new Set(arg)]);
        },
    },
    "hash_hmac": {
		// eslint-disable-next-line max-params
        to: (hashType, content, key, keyEncoding) => {
            if (keyEncoding) {
                key = Buffer.from(key, keyEncoding);
            }
            return crypto.createHmac(hashType, key).update(content).digest('hex');
        }
    },
    "hash": {
        to: (hashType, content) => {
            return crypto.createHash(hashType).update(content).digest('hex');
        }
    },
    "if": {
        to: (condition, trueValue, falseValue) => {
            return condition ? trueValue : falseValue;
        }
    }
};

export function invokeConversionFunction(fName, args : string[]) {
    let handler = handlers[String(fName).toLowerCase()];
    if (!handler) {
        throw new Error("Unknown function " + fName);
    }

    return handler.to(...args);
}

export function convertOneVariable(direction, conversions : string[], value) {
    for (let handler of conversions) {
        let dir = direction;
        if (!handlers[String(handler).toLowerCase()]) {
            continue;
        }

        if (!value) {
            continue;
        }

        if (dir) {
            value = handlers[String(handler).toLowerCase()].to(value);
        } else {
            value = handlers[String(handler).toLowerCase()].from(value);
        }
    }

    return value;
}

export function convertVariables(direction: boolean, conversions : Array, vars) {
    /* usually conversions are not defined - so we return original value */
    if (!conversions || !Array.isArray(conversions)) {
        return vars;
    }

    for (let variable of Object.keys(vars)) {
        for (let handler of conversions) {
            if (handler.match === variable || handler.match === "*") {
                let value = vars[variable];
                let dir = direction;
                if (handler.inverse) {
                    dir = !dir;
                }
                if (dir) {
                    value = handlers[String(handler.type).toLowerCase()].to(value);
                } else {
                    value = handlers[String(handler.type).toLowerCase()].from(value);
                }
                vars[variable] = value;
            }
        }
    }

    return vars;
}
